export var StatusEnum;
(function (StatusEnum) {
    StatusEnum["DRAFT"] = "DRAFT";
    StatusEnum["SUBMITTED"] = "SUBMITTED";
    StatusEnum["DELETED"] = "DELETED";
    StatusEnum["AUTHORISED"] = "AUTHORISED";
    StatusEnum["PAID"] = "PAID";
    StatusEnum["VOIDED"] = "VOIDED";
})(StatusEnum || (StatusEnum = {}));
export var TypeEnum;
(function (TypeEnum) {
    TypeEnum["ACCREC"] = "ACCREC";
    TypeEnum["ACCPAY"] = "ACCPAY";
})(TypeEnum || (TypeEnum = {}));
//# sourceMappingURL=xero.js.map